import React, { useState, useEffect } from "react";
import { Steps } from "antd";
import Phone from "./Phone";
import SignupScreen from "./SignupScreen";
import PersonalData from "./PersonalData";
import ChangeLanguage from "../../../components/ChangeLanguage";
import { Link, useHistory } from "react-router-dom";
import strings from "../../../strings";

// Redux imports for subscription
import { connect } from "react-redux";
import { toggleSubscribeModal, checkSubscriptionStatus } from "../../../redux/actions/renewalActions";
import { getPricingPlanData } from "../../../redux/actions/merchantAction";
import SubscriptionModal from "../../../components/StripePayment/subscriptionModal";
import { fetchActiveApps } from "../../../redux/actions/appActions";

const { Step } = Steps;

const Signup = ({
  isSubscribeModalOpen,
  toggleSubscribeModal,
  checkSubscriptionStatus,
  getPricingPlanData,
  fetchActiveApps,
  auth
}) => {
  useEffect(() => {
    window.location.href = "https://sell.loystar.co/signup";
  }, []);

  const history = useHistory();
  const [current, setCurrent] = useState(0);
  const [textLabel, setTextLabel] = useState("");
  const [phone, setPhone] = useState("");
  const [countryData, setCountryData] = useState(null);
  const [personalDataFields, setPersonalDataFields] = useState({});
  
  // State to persist all form data across steps
  const [formData, setFormData] = useState({
    // Step 1 - Phone data
    phoneData: {
      phone_number: ""
    },
    // Step 2 - Personal data
    personalData: {
      first_name: "",
      last_name: "",
      email: "",
      business_name: "",
      business_type_id: ""
    },
    // Step 3 - Address and password data
    signupData: {
      address_line1: "",
      address_line2: "",
      postcode: "",
      password: "",
      confirmPassword: "",
      ref_code: "",
      captcha_response: "",
      isChecked: false
    }
  });

  // Function to update specific step data
  const updateFormData = (step, data) => {
    setFormData(prev => ({
      ...prev,
      [step]: {
        ...prev[step],
        ...data
      }
    }));
  };

  // Function to handle successful signup and redirect to dashboard
  const handleSignupSuccess = (user) => {
    // Store subscription modal trigger in localStorage for dashboard to pick up
    localStorage.setItem('triggerSubscriptionModal', 'true');
    localStorage.setItem('newSignupUser', JSON.stringify(user));
    localStorage.setItem('isTrialMode', 'true'); // Enable trial mode for new signups
    
    // Load Trial plan pricing data - new merchants enroll in paid trial
    const getTrialPlanData = getPricingPlanData({ plan_name: "Trial" });

    getTrialPlanData
      .then((trial) => {
        const subscriptionPlanPrice = {
          trial: trial.data
        };
        
        localStorage.setItem('subscriptionPlanPrice', JSON.stringify(subscriptionPlanPrice));
        
        // Check subscription status
        checkSubscriptionStatus(user.id);
        
        // Fetch active apps for pricing
        fetchActiveApps();
        
        // Redirect to dashboard
        history.push("/sales");
      })
      .catch((err) => {
        console.error("Error loading subscription data:", err);
        // Still redirect even if pricing data fails
        history.push("/sales");
      });
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: strings.enterPhoneNumber,
      content: (
        <Phone
          next={next}
          setTextLabel={setTextLabel}
          setPhone={setPhone}
          setCountryData={setCountryData}
          formData={formData.phoneData}
          updateFormData={updateFormData}
        />
      ),
    },

    {
      title: strings.personalData,
      content: (
        <PersonalData
          next={next}
          previous={prev}
          setPersonalDataFields={setPersonalDataFields}
          formData={formData.personalData}
          updateFormData={updateFormData}
        />
      ),
    },
    {
      title: strings.validateConfirmationCOde,
      content: (
        <SignupScreen
          phone={phone}
          personalDataFields={personalDataFields}
          countryData={countryData}
          formData={formData.signupData}
          updateFormData={updateFormData}
          previous={prev}
          onSignupSuccess={handleSignupSuccess}
        />
      ),
    },
  ];

  return (
    <div className="step-container">
      <ChangeLanguage />
      <div className="step--wrapper">
        <h1 className="title">{strings.signUp}</h1>

        <div className="logo">
          <img src="/assets/img/loystar-logo.png" alt="App Logo" />
        </div>
        <p style={{ textAlign: "center" }}>
          <em>The purpose of a business is to sell and keep customers</em>
        </p>

        <div
          className="auth-form__container"
          style={{ margin: "0 auto", maxWidth: "400px" }}
        >
          <Steps className="step-list" size="small" current={current}>
            {steps.map((item) => (
              <Step key={item.title} />
            ))}
          </Steps>

          <div className="steps-content">{steps[current].content}</div>

          <div className="form-utils__container">
            <Link to="/signin">{strings.signIn}</Link>
            {/* <Link to="/reset-password">Forgot Password?</Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isSubscribeModalOpen: state.renewal.isSubscribeModalOpen,
  auth: state.auth
});

export default connect(mapStateToProps, {
  toggleSubscribeModal,
  checkSubscriptionStatus,
  getPricingPlanData,
  fetchActiveApps
})(Signup);
